import React from "react"

export const ErrorComponent = ({ error }) => {
  console.log(error)
  return <div>An Error Occurred: {error.errorCode}</div>
}
